
let DataManager = function () {
  if (DataManager.prototype._singletonInstance) {
    return DataManager.prototype._singletonInstance;
  }

  DataManager.prototype._singletonInstance = this;

  // console.log('local achievements', this.achievements);

  // default score object, these values are saved using the sdk
  this.score = { active: 0, high: 0 };

  // default state object, this gets saved to the users account via the sdk api
  this.state = { musicOn: true, soundsOn: true, coinCount: 0 };

  // session memory, these values are not saved across sessions or by the sdk
  this.session = { checkPointScore: 0, lastMapIndex: 0, coinCount: 0, beeMoneyCount: 0, continueAvailable: true };

  this.getSaveData();

};

DataManager.prototype.checkHighScore = function () {
  // console.log('DataManager.checkHighScore');
  if (this.score.active > this.score.high) {
    this.score.high = this.score.active;
    this.setSaveData();
  }
};

DataManager.prototype.addPoints = function (points) {
  this.score.active += points;
};

DataManager.prototype.setScore = function (points) {
  this.score.active = points;
};

DataManager.prototype.getScore = function () {
  return this.score.active;
};

DataManager.prototype.getHighScore = function () {
  return this.score.high;
};

DataManager.prototype.addCoins = function (coins) {
  this.session.coinCount += coins;
};

DataManager.prototype.setCoins = function (coins) {
  // console.log('DataManager.setCoins');
  this.session.coinCount = coins;
  this.saveCoins();
};

DataManager.prototype.getCoins = function () {
  return this.session.coinCount;
};

DataManager.prototype.saveCoins = function () {
  // console.log('DataManager.saveCoins');
  this.setItem('coinCount', this.getCoins());
};

DataManager.prototype.clearActiveScore = function () {
  this.score.active = 0;
};

DataManager.prototype.setItem = function (key, value) {
  // console.log('DataManager.setItem', key, value);
  this.state[key] = value;
  this.setSaveData();
};

DataManager.prototype.getItem = function (key) {
  // console.log('DataManager.getItem', key);
  return this.state[key];
};

DataManager.prototype.setSessionItem = function (key, value) {
  // console.log('DataManager.setSessionItem', key, value);
  this.session[key] = value;
};

DataManager.prototype.getSessionItem = function (key) {
  // console.log('DataManager.getSessionItem', key);
  return this.session[key];
};

DataManager.prototype.addAchievementProgress = function (local, value) {

};

DataManager.prototype.getAchievementProgress = function (local, cb) {

};

DataManager.prototype.unlockAchievement = function (local) {

};

DataManager.prototype.setSaveData = function () {
  var data = {
    score: this.score.high,
    musicOn: this.state.musicOn,
    soundsOn: this.state.soundsOn,
    coinCount: this.state.coinCount
  };
  localStorage.setItem('teen_titans_rumble_bee', JSON.stringify(data));
};

DataManager.prototype.getSaveData = function () {
  var localStorageData = localStorage.getItem('teen_titans_rumble_bee');
  
  if(localStorageData){
    localStorageData = JSON.parse(localStorageData);

    this.score.high = localStorageData.score;
    this.state.musicOn = localStorageData.musicOn;
    this.state.soundsOn = localStorageData.soundsOn;
    this.state.coinCount = localStorageData.coinCount;
  }
};

export default DataManager;
